import {
    FETCH_ALL_COUNTRY_SUCCESS, EDIT_COUNTRY, UPDATE_COUNTRY_SUCCESS, CREATE_COUNTRY_SUCCESS, DELETE_COUNTRY_SUCCESS,
    FETCH_ALL_CONTRY_LANG_SUCCESS, EDIT_CONTRY_LANG, UPDATE_CONTRY_LANG_SUCCESS, CREATE_CONTRY_LANG_SUCCESS, DELETE_CONTRY_LANG_SUCCESS,
    FETCH_ALL_SPECIALITY_SUCCESS, EDIT_SPECIALITY, UPDATE_SPECIALITY_SUCCESS, CREATE_SPECIALITY_SUCCESS, DELETE_SPECIALITY_SUCCESS,
    FETCH_ALL_LANG_SUCCESS, EDIT_LANG, UPDATE_LANG_SUCCESS, CREATE_LANG_SUCCESS, DELETE_LANG_SUCCESS,
    FETCH_ALL_CONTENT_TYPES_SUCCESS,
    FETCH_ALL_HEALTH_PARTNER_TYPES_SUCCESS,
    FETCH_ALL_ROLES_SUCCESS,
    //   FETCH_ALL_FEATURE_TYPES,
    FETCH_ALL_FEATURE_TYPES_SUCCESS,
    FETCH_REPORT_CONFIG_SUCCESS,
    UPDATE_REPORT_CONFIG_SUCCESS,
    CREATE_DOCTOR_REPORTS_SUCCESS,
    VIEW_DOCTOR_REPORTS_SUCCESS,
    VIEW_DOCTOR_REPORTS_CLEAN,
} from "constants/master_data.constants";

const INIT_STATE = {
    countries: [],
    country_langs: [],
    specialities: [],
    content_types: [],
    health_partner_types: [],
    roles: [],
    feature_types: [],
    langs: [],
    config: {
        id: 0,
        frequency: "",
        sheduled_date: 0,
        sheduled_day: "",
        sheduled_time: ""
    },
    configs: [],
    doctor_reports_data: {
        total: 0,
        sub_total: 0, 
        data: [],
        pagination: ""
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case FETCH_ALL_FEATURE_TYPES_SUCCESS: {
            return {
                ...state,
                feature_types: action.payload.data
            }
        }

        case FETCH_ALL_HEALTH_PARTNER_TYPES_SUCCESS: {
            return {
                ...state,
                health_partner_types: action.payload.data
            }
        }

        case FETCH_ALL_CONTENT_TYPES_SUCCESS: {
            return {
                ...state,
                content_types: action.payload.data
            }
        }

        case FETCH_ALL_ROLES_SUCCESS: {
            return {
                ...state,
                roles: action.payload.roles
            }
        }


        case FETCH_ALL_COUNTRY_SUCCESS: {
            return {
                ...state,
                countries: action.payload.data
            }
        }

        case UPDATE_COUNTRY_SUCCESS: {
            var foundIndex = state.countries.findIndex(x => x.id === action.payload.data.id);
            let all = Object.assign([], state.countries);
            all[foundIndex] = action.payload.data
            return {
                ...state,
                countries: all,
                country: null
            }
        }

        case CREATE_COUNTRY_SUCCESS: {
            let all = Object.assign([], state.countries);
            all.push(action.payload.data)
            return {
                ...state,
                countries: all,
                country: null
            }
        }

        case DELETE_COUNTRY_SUCCESS: {
            let all = Object.assign([], state.countries);
            var newArray = all.filter(function (c) {
                return c.id !== action.payload.id
            });
            return {
                ...state,
                countries: newArray,
            }
        }

        case EDIT_COUNTRY: {
            return {
                ...state,
                country: state.countries.find(c => c.id === action.payload)
            }
        }
        //start country_lang
        case FETCH_ALL_CONTRY_LANG_SUCCESS: {
            return {
                ...state,
                country_langs: action.payload.data
            }
        }

        case UPDATE_CONTRY_LANG_SUCCESS: {
            let foundIndex = state.country_langs.findIndex(x => x.id === action.payload.data.id);
            let all = Object.assign([], state.country_langs);
            all[foundIndex] = action.payload.data
            return {
                ...state,
                country_langs: all,
                country_lang: null,
                lang: null
            }
        }

        case CREATE_CONTRY_LANG_SUCCESS: {
            let all = Object.assign([], state.country_langs);
            all.push(action.payload.data)
            return {
                ...state,
                country_langs: all,
                country_lang: null,
                lang: null
            }
        }

        case DELETE_CONTRY_LANG_SUCCESS: {
            let all = Object.assign([], state.country_langs);
            let newArray = all.filter(function (c) {
                return c.id !== action.payload.id
            });
            return {
                ...state,
                country_langs: newArray,
            }
        }

        case EDIT_CONTRY_LANG: {
            return {
                ...state,
                country_lang: state.country_langs.find(c => c.id === action.payload)
            }
        }

        //start speciality
        case FETCH_ALL_SPECIALITY_SUCCESS: {
            return {
                ...state,
                specialities: action.payload.data
            }
        }

        case UPDATE_SPECIALITY_SUCCESS: {
            let foundIndex = state.specialities.findIndex(x => x.id === action.payload.data.id);
            let all = Object.assign([], state.specialities);
            all[foundIndex] = action.payload.data
            return {
                ...state,
                specialities: all,
                speciality: null
            }
        }

        case CREATE_SPECIALITY_SUCCESS: {
            let all = Object.assign([], state.specialities);
            all.push(action.payload.data)
            return {
                ...state,
                specialities: all,
                speciality: null
            }
        }

        case DELETE_SPECIALITY_SUCCESS: {
            let all = Object.assign([], state.specialities);
            let newArray = all.filter(function (c) {
                return c.id !== action.payload.id
            });
            return {
                ...state,
                specialities: newArray,
            }
        }

        case EDIT_SPECIALITY: {
            return {
                ...state,
                speciality: state.specialities.find(c => c.id === action.payload)
            }
        }

        //start lang
        case FETCH_ALL_LANG_SUCCESS: {
            return {
                ...state,
                langs: action.payload.data
            }
        }

        case UPDATE_LANG_SUCCESS: {
            let foundIndex = state.langs.findIndex(x => x.id === action.payload.data.id);
            let all = Object.assign([], state.langs);
            all[foundIndex] = action.payload.data
            return {
                ...state,
                langs: all,
                lang: null
            }
        }

        case CREATE_LANG_SUCCESS: {
            let all = Object.assign([], state.langs);
            all.push(action.payload.data)
            return {
                ...state,
                langs: all,
                lang: null
            }
        }

        case DELETE_LANG_SUCCESS: {
            let all = Object.assign([], state.langs);
            let newArray = all.filter(function (c) {
                return c.id !== action.payload.id
            });
            return {
                ...state,
                langs: newArray,
            }
        }

        case EDIT_LANG: {
            return {
                ...state,
                lang: state.langs.find(c => c.id === action.payload)
            }
        }

        //start config
        case FETCH_REPORT_CONFIG_SUCCESS: {
            return {
                ...state,
                configs: action.payload.data
            }
        }

        case UPDATE_REPORT_CONFIG_SUCCESS: {
            let all = Object.assign([], state.configs);
            action.payload.data.forEach(element => {
                let foundIndex = state.configs.findIndex(x => x.id === element.id);
                all[foundIndex] = element
            });
            return {
                ...state,
                configs: all,
                config: null
            }
        }

        case CREATE_DOCTOR_REPORTS_SUCCESS: {
            let all = Object.assign([], state.configs);
            all.push(action.payload.data)
            return {
                ...state,
                configs: all,
                config: null
            }
        }
        case VIEW_DOCTOR_REPORTS_SUCCESS: {
            return {
                ...state,
                doctor_reports_data : {
                    ...state.doctor_reports_data,
                    total: action.payload.data.total,
                    sub_total: action.payload.data.sub_total,
                    data: action.payload.data.data,
                    pagination: action.payload.paginate
                }
            }
        }
        case VIEW_DOCTOR_REPORTS_CLEAN: {
            return {
                ...state,
                doctor_reports_data : INIT_STATE.doctor_reports_data
            }
        }
        default:
            return state;
    }
}